// router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import App from '@/App.vue'
import RosterPage from '@/views/RosterPage.vue'

// Cycling Jersey 页面组件
import cyclingjersey from '@/views/cyclingjersey.vue'
import cyclingjerseys from '@/views/cyclingjerseys.vue'
import cyclingjerseyroster from '@/views/cyclingjerseyroster.vue'

// MX Jersey 页面组件
import mxjersey from '@/views/mxjersey.vue'
import mxjerseys from '@/views/mxjerseys.vue'
import mxjerseyroster from '@/views/mxjerseyroster.vue'

// tshirtroster 页面组件
import tshirt from '@/views/tshirt.vue'
import tshirts from '@/views/tshirts.vue'
import tshirtroster from '@/views/tshirtroster.vue'

// ========== Vue Router 配置 ==========
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: App
    },
    // ========== Cycling Jersey 路由 ==========
    {
      path: '/cyclingjersey',
      name: 'cyclingjersey',
      component: cyclingjersey,
      meta: { title: 'Cycling Jersey Designer' }
    },
    {
      path: '/cyclingjerseys',
      name: 'cyclingjerseys',
      component: cyclingjerseys,
      meta: { title: 'Cycling Jersey Review' }
    },
    {
      path: '/cyclingjerseyroster',
      name: 'cyclingJerseyRoster',
      component: cyclingjerseyroster,
      meta: { title: 'Cycling Jersey Roster' }
    },
    // ========== MX Jersey 路由 ==========
    {
      path: '/mxjersey',
      name: 'mxjersey',
      component: mxjersey,
      meta: { title: 'MX Jersey Designer' }
    },
    {
      path: '/mxjerseys',
      name: 'mxjerseys',
      component: mxjerseys,
      meta: { title: 'MX Jersey Review' }
    },
    {
      path: '/mxjerseyroster',
      name: 'mxjerseyroster',
      component: mxjerseyroster,
      meta: { title: 'MX Jersey Roster' }
    },
    // ========== T-Shirt 路由 ==========
    {
      path: '/tshirt',
      name: 'tshirt',
      component: tshirt,
      meta: { title: 'T-Shirt Designer' }
    },
    {
      path: '/tshirts',
      name: 'tshirts',
      component: tshirts,
      meta: { title: 'T-Shirt Review' }
    },
    {
      path: '/tshirtroster',
      name: 'tshirtroster',
      component: tshirtroster,
      meta: { title: 'T-Shirt Roster' }
    },
    // ========== Review 路由 ==========
    {
      path: '/review',
      name: 'review',
      component: () => import('@/views/review.vue'),
      meta: { title: 'Review Design' }
    }
  ]
})

// 全局路由守卫：设置页面标题
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// 只导出 router（Vuex 已移除）
export { router }